import { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
} from "reactstrap";

interface ModalConfirmProps {
  openModal: boolean;
  closeModal: () => void;
  handleConfirm: () => void;
  title?: string;
  message?: React.ReactNode;
  /**
   * Palavra que o usuário precisa digitar para habilitar o botão de confirmação.
   * Reservado para ações com cascata de dados real e irreversível (ex.: excluir
   * Contrato, Aluno, remover curso do contrato). Quando omitido, o modal pede
   * apenas um clique de confirmação — use para ações de baixo risco (cadastros
   * simples, tabelas de tipo/lookup), para não gerar fadiga de confirmação.
   */
  confirmWord?: string;
  confirmButtonLabel?: string;
  /** Enquanto true, desabilita os botões e mostra estado de carregamento. */
  loading?: boolean;
}

const ModalConfirm = ({
  openModal,
  closeModal,
  handleConfirm,
  title = "Confirmar exclusão",
  message = "Você realmente deseja excluir este registro? Esta ação não pode ser desfeita.",
  confirmWord,
  confirmButtonLabel = "Excluir",
  loading = false,
}: ModalConfirmProps) => {
  const [typedWord, setTypedWord] = useState("");

  useEffect(() => {
    if (openModal) setTypedWord("");
  }, [openModal]);

  const isConfirmEnabled = !loading && (!confirmWord || typedWord === confirmWord);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && isConfirmEnabled) {
      handleConfirm();
    }
  };

  return (
    <Modal isOpen={openModal} toggle={loading ? undefined : closeModal} centered>
      <ModalHeader toggle={loading ? undefined : closeModal}>{title}</ModalHeader>
      <ModalBody>
        <p>{message}</p>
        {confirmWord && (
          <FormGroup className="mb-0">
            <label className="form-control-label" htmlFor="modal-confirm-input">
              Para confirmar, digite <strong>{confirmWord}</strong> abaixo:
            </label>
            <Input
              id="modal-confirm-input"
              autoFocus
              autoComplete="off"
              value={typedWord}
              onChange={(e) => setTypedWord(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder={confirmWord}
              disabled={loading}
            />
          </FormGroup>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={closeModal} disabled={loading}>
          Cancelar
        </Button>
        <Button color="danger" onClick={handleConfirm} disabled={!isConfirmEnabled}>
          {loading ? "Excluindo..." : confirmButtonLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalConfirm;
